import { render, staticRenderFns } from "./MenuPromotion.vue?vue&type=template&id=a939e0f8&scoped=true&"
import script from "./MenuPromotion.vue?vue&type=script&lang=js&"
export * from "./MenuPromotion.vue?vue&type=script&lang=js&"
import style0 from "./MenuPromotion.vue?vue&type=style&index=0&id=a939e0f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a939e0f8",
  null
  
)

export default component.exports